import { render, staticRenderFns } from "./ActualizationForm.vue?vue&type=template&id=49009066&"
import script from "./ActualizationForm.vue?vue&type=script&lang=js&"
export * from "./ActualizationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSpace,QItem,QInput,QBtn,QTooltip,QInnerLoading,QSpinnerGears,QSeparator,QCardActions} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QSpace,QItem,QInput,QBtn,QTooltip,QInnerLoading,QSpinnerGears,QSeparator,QCardActions}, component.options.components || {})
